import React from 'react';
import { getResourcePath, trans } from '@spotahome/soyuz/client';

import PhotoScrollerList from './PhotoScrollerList';
import Viewer360 from './Viewer360';

const COMMON_IMAGE_PATH = '/images/phone-scroller';

const photoList = Array.from({ length: 10 }, (_, index) => {
  const photoName = `media-photo-${(index + 1).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })}`;
  return {
    src: getResourcePath(
      `${COMMON_IMAGE_PATH}/media-photo/${photoName}-1x.jpg`
    ),
    srcSet: `${getResourcePath(
      `${COMMON_IMAGE_PATH}/media-photo/${photoName}-2x.jpg`
    )} 2x, ${getResourcePath(
      `${COMMON_IMAGE_PATH}/media-photo/${photoName}-3x.jpg`
    )} 3x`,
    description: photoName
  };
});

export const getStaticMediaList = () => [
  {
    title: trans('landlord.landing.standard.scroller-list.video-tour.title'),
    content: trans(
      'landlord.landing.standard.scroller-list.video-tour.subtitle'
    ),
    imageName: 'media-video'
  },
  {
    title: trans(
      'landlord.landing.standard.scroller-list.professional-photos.title'
    ),
    content: trans(
      'landlord.landing.standard.scroller-list.professional-photos.subtitle'
    ),
    imageName: 'media-photos'
  },
  {
    title: trans('landlord.landing.standard.scroller-list.360-photos.title'),
    content: trans(
      'landlord.landing.standard.scroller-list.360-photos.subtitle'
    ),
    imageName: 'media-360'
  },
  {
    title: trans('landlord.landing.standard.scroller-list.floor-plans.title'),
    content: trans(
      'landlord.landing.standard.scroller-list.floor-plans.subtitle'
    ),
    imageName: 'media-floorplan'
  }
];

export const getMediaList = () => [
  {
    title: trans('landlord.landing.standard.scroller-list.video-tour.title'),
    titleText: trans(
      'landlord.landing.standard.scroller-list.video-tour.subtitle'
    ),
    renderFrameContent: () => {
      return (
        <video autoPlay loop playsInline muted style={{ width: '100%' }}>
          <source
            src={getResourcePath('/videos/media-video-homecheckers.webm')}
          />
          <source
            src={getResourcePath('/videos/media-video-homecheckers.mp4')}
          />
        </video>
      );
    }
  },
  {
    title: trans(
      'landlord.landing.standard.scroller-list.professional-photos.title'
    ),
    titleText: trans(
      'landlord.landing.standard.scroller-list.professional-photos.subtitle'
    ),
    renderFrameContent: () => <PhotoScrollerList photoList={photoList} />
  },
  {
    title: trans('landlord.landing.standard.scroller-list.360-photos.title'),
    titleText: trans(
      'landlord.landing.standard.scroller-list.360-photos.subtitle'
    ),
    renderFrameContent: () => {
      const slideName = 'media-360';
      const srcString = `${COMMON_IMAGE_PATH}/${slideName}.jpg`;
      return (
        <div className="showcase-features__view-360">
          <Viewer360
            id="view360"
            src={getResourcePath(srcString)}
            config={{
              autoLoad: false,
              preview: getResourcePath(
                `/images/phone-scroller/media-360-preview.jpg`
              )
            }}
          />
        </div>
      );
    }
  },
  {
    title: trans('landlord.landing.standard.scroller-list.floor-plans.title'),
    titleText: trans(
      'landlord.landing.standard.scroller-list.floor-plans.subtitle'
    ),
    renderFrameContent: () => {
      const slideName = 'media-floorplan';
      const srcString = `${COMMON_IMAGE_PATH}/${slideName}-1x.jpg`;
      return <img src={getResourcePath(srcString)} alt={slideName} />;
    }
  }
];

export default { getStaticMediaList, getMediaList };
